var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a-alert"},[_c('rn-icon',{attrs:{"height":"17px","width":"17px","name":_vm.icon || 'warning'}}),_c('span',[_vm._v(_vm._s(_vm.message))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }